import { M_Button } from "../../../../M_Components"
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ITEM_TYPE } from "../AdminPage";
import { AddCircleOutlineOutlined } from '@mui/icons-material';

export const ConfigurationsAddButton = ({ onAddClickCallback, isEnabled }) => {
  const [t, i18n] = useTranslation();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const options = Object.keys(ITEM_TYPE).filter(t => t !== "Field");
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleClick = (type) => {
    onAddClickCallback(type);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  return (
    <>

      <M_Button
        tooltip={t("NgeCreateField")}
        label={t("Field")}
        icon={<AddCircleOutlineOutlined style={{ color: 'var(--color-green-light)' }} />}
        hoverEffect
        disabled={!isEnabled}
        onClick={() => handleClick(ITEM_TYPE.Field)}
      />
    </>
  )
}